import { supabase } from "./db_connection";

export const getHierarchyData = async () => {
  const { data, error } = await supabase
    .from("profiles")
    .select("*")
    .eq("is_active", true);

  if (error) {
    console.error("Supabase Error:", error);
    return [];
  }

  console.log("Fetched hierarchy data:", data);
  return data;
};